import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ChatWidget from '../../components/ChatWidget';

export default function WidgetEmbed() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);
  
  const agentId = searchParams.get('agentId');
  const userId = searchParams.get('userId');
  
  // Get styling params
  const backgroundColor = searchParams.get('backgroundColor') || '';
  const textColor = searchParams.get('textColor') || ''; // Controls header text
  const chatTextColor = searchParams.get('chatTextColor') || ''; // Controls chat messages text
  const headerColor = searchParams.get('headerColor') || '';
  const buttonColor = searchParams.get('buttonColor') || '';
  const borderRadius = searchParams.get('borderRadius') || '';
  
  const wsUrl = process.env.REACT_APP_SOCKET_URL + '/chat';

  useEffect(() => {
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100vh';
    document.documentElement.style.height = '100vh';
    
    console.log('=== WidgetEmbed Loaded ===');
    console.log('Agent ID:', agentId);
    console.log('User ID:', userId);
    console.log('Styling:', { backgroundColor, textColor, chatTextColor, headerColor, buttonColor, borderRadius });
    console.log('==========================');
    
    if (!agentId) {
      setError('Agent ID is required');
    }
    
    if (window.parent && window.parent !== window.self) {
      window.parent.postMessage({ type: 'widget-ready' }, '*');
    }
  }, [agentId, userId, backgroundColor, textColor, chatTextColor, headerColor, buttonColor, borderRadius]);

  if (error) {
    return (
      <div style={{ 
        width: '100%', 
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'sans-serif'
      }}>
        <div style={{ textAlign: 'center', color: 'red' }}>
          <h3>Error: {error}</h3>
        </div>
      </div>
    );
  }

  if (!agentId) {
    return (
      <div style={{ 
        width: '100%', 
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'sans-serif'
      }}>
        <div style={{ textAlign: 'center' }}>
          <h3>Loading widget...</h3>
        </div>
      </div>
    );
  }

  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <ChatWidget 
        agentId={agentId} 
        userId={userId}
        wsUrl={wsUrl}
        isEmbed={true}
        backgroundColor={backgroundColor}
        textColor={textColor}
        chatTextColor={chatTextColor}
        headerColor={headerColor}
        buttonColor={buttonColor}
        borderRadius={borderRadius}
      />
    </div>
  );
}